import React, { Component, Fragment } from 'react';
import ModalT1 from "./Modal";
import { SingleDatePicker } from 'react-dates';
import Input from 'Components/Input/index';
import Select from 'react-select';
import { ReactComponent as UploadIcon } from 'Icons/upload.svg';
import { isDesmetSupplier } from 'Utils/index';
import Classnames from 'classnames';
import { ReactComponent as PhotoLibrary } from 'Icons/photo-library.svg';
import {  ReactComponent as Calender } from 'Icons/calender.svg';
import { ReactComponent as Edit } from 'Icons/editIconT1.svg';
import { ReactComponent as Delete } from 'Icons/delete.svg';
import Upload from "Components/Upload/index";
import Moment from 'moment';
import RemarksConfirmationPopup from './remarksConfirmationPopup';
class RawMaterialStatus extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isRejectPopup: false
        }
    }

    handleReject = (material = '') => {
        this.setState(prevState => {
            return {
                isRejectPopup: !prevState.isRejectPopup,
                remarks: '',
                material
            }
        })
    }

    onConfirm = () => {
        const { material, remarks } = this.state;
        this.props.onClickApproveOrReject(1, 2, material, this.props.partData, remarks);
        this.handleReject();
    }

    render() {
    const { rawMaterials, poDropdownLists, isModalPopupOpen, handleModalPopupClose, partData, editId, onClickEdit, onClickApproveOrReject } = this.props;
    const isSupplier =  isDesmetSupplier();
        return (
            <Fragment>
                <ModalT1 
                    isOpenState={isModalPopupOpen}
                    handleOnClickForClose={handleModalPopupClose}>
                        <div className={Classnames('raw-modal pv-10 ph-10', {
                            'wt-1000': !isSupplier })}>
                            <div className={'fs-20 fSemibold'}>Raw Material Status</div>
                            <div className="fs-16 fSemibold mt-20">
                               <span>Item Number : </span><span style={{'color': '#597EF7'}}>{partData.part_number}</span> 
                                <span style={{'color': '#858991'}}> <b className="ml-10 mr-10">|</b> Net Weight : {partData.net_weight}  Kg</span>
                            </div>
                            <div style={{'border': '1px solid #D3D9EC'}} className={'mt-20 br-5'}>
                                {isSupplier && <div className="pv-10 ph-10 flex flex-between flex-middle">
                                    <div className={'fs-18 fSemibold'}>Rm Required Details</div>
                                {!(rawMaterials || []).find(el => el.raw_material_id) && <div className="divButton curP" onClick={this.props.onAddRmRequirement}>+ Add Rm Requirement</div>}
                                </div>}
                                <div className={'rmTable'}>
                                    <table width={'100%'} cellSpacing={0}>
                                        {isSupplier ?
                                        <>
                                            <tr>
                                                <th className={'wt-200'}>Product Type</th>
                                                <th>Product Description</th>
                                                <th className={'wt-150'}>Product Grade</th>
                                                <th className={'wt-100'}>Required Quantity</th>
                                                <th>Required Date</th>
                                                <th>Expected Date</th>
                                                <th>Upload Document</th>
                                                <th>Approval Required</th>
                                                <th>Remark</th>
                                                <th>Actions</th>
                                            </tr>
                                            {(rawMaterials || []).map((material, mIndex) => {
                                                const isUnEditable = (material.raw_material_id && editId !=  material.raw_material_id)
                                            return(<tr>
                                            <td className={isUnEditable ? 'disabled' : ''}>
                                                    <Select 
                                                        placeholder={'Select Product Type'}
                                                        options={poDropdownLists.productType || []}
                                                        getOptionLabel={(option) => option.value}
                                                        getOptionValue={(option) => option.id}
                                                        value={material.product_type && (poDropdownLists.productType || []).find(el => el.value === material.product_type)}
                                                        onChange={(option) => this.props.onSelectRawMaterial(option, mIndex, 'product_type', 'product_type_id')}
                                                    />
                                            </td>
                                            <td className={isUnEditable ? 'disabled' : ''}>
                                                    <Input 
                                                        className={'fs-14'}
                                                        placeholder={'Enter Product Description'}
                                                        value={material.product_description}
                                                        name={'product_description'}
                                                        onChange={(e) => this.props.onChangeRawMaterial(e, mIndex)}
                                                    />
                                                </td>
                                            <td className={isUnEditable ? 'disabled' : ''}>
                                                <Select 
                                                    options={poDropdownLists.productGrade || []}
                                                    getOptionLabel={(option) => option.value}
                                                    getOptionValue={(option) => option.id}
                                                    value={material.product_grade && (poDropdownLists.productGrade || []).find(el => el.value === material.product_grade)}
                                                    onChange={(option) => this.props.onSelectRawMaterial(option, mIndex, 'product_grade', 'product_grade_id')}
                                            /></td>
                                            <td className={isUnEditable ? 'disabled' : ''}>
                                                    <Input 
                                                        className={'fs-14'}
                                                        type={'number'}
                                                        placeholder={'Enter Required Qunatity'}
                                                        value={material.required_quantity}
                                                        name={'required_quantity'}
                                                        onChange={(e) => this.props.onChangeRawMaterial(e, mIndex)}
                                                    />
                                                </td>
                                                <td className={isUnEditable ? 'disabled' : ''}>
                                                    <SingleDatePicker 
                                                        className="pInput" 
                                                        customInputIcon={[<Calender className='wt-15 ht-15'/>]} 
                                                        inputIconPosition={'after'}
                                                        displayFormat={"DD MMM YYYY"}
                                                        isOutsideRange={() => false}
                                                        hideKeyboardShortcutsPanel={true}
                                                        placeholder={"dd/mm/yyyy"}
                                                        numberOfMonths={2}
                                                        date={material.required_date ? Moment(material.required_date) : ''} 
                                                        onDateChange={(date) => this.props.onChangeRawMaterialsDate(date, 'required_date', mIndex)}
                                                        focused={this.state[`focusedRequiredDate${mIndex}`]}
                                                        onFocusChange={({ focused }) => this.setState({ [`focusedRequiredDate${mIndex}`]: focused })}
                                                    />
                                                </td>
                                            <td className={isUnEditable ? 'disabled' : ''}>
                                                    <SingleDatePicker 
                                                        className="pInput" 
                                                        customInputIcon={[<Calender className='wt-15 ht-15'/>]} 
                                                        inputIconPosition={'after'}
                                                        displayFormat={"DD MMM YYYY"}
                                                        isOutsideRange={() => false}
                                                        hideKeyboardShortcutsPanel={true}
                                                        placeholder={"dd/mm/yyyy"}
                                                        numberOfMonths={2}
                                                        date={material.expected_date ? Moment(material.expected_date) : ''} 
                                                        onDateChange={(date) => this.props.onChangeRawMaterialsDate(date, 'expected_date', mIndex)}
                                                        focused={this.state[`focusedExpectedDate${mIndex}`]}
                                                        onFocusChange={({ focused }) => this.setState({ [`focusedExpectedDate${mIndex}`]: focused })}
                                                    />
                                                </td>
                                            <td>
                                                <Upload onChange={(file) => this.props.onUploadDocument(file, mIndex, 1)}  className={isUnEditable ? 'disabled' : ''}>
                                                    <UploadIcon className={isUnEditable ? 'disabled wt-25 ht-25 ' : 'wt-25 ht-25 curP'}/>
                                                </Upload>
                                                {(material.uploaded_doc || {}).name && <div className={'uploaded-data fs-14'}>
                                                            <a href={(material.uploaded_doc || {}).url} download><PhotoLibrary className="mr-10 wt-15 ht-15" />{(material.uploaded_doc || {}).name}</a>
                                                    </div>}
                                            </td>
                                            <td className={isUnEditable ? 'disabled' : ''}> 
                                                <div className="switch" >
                                                    <input type="checkbox"  checked={material.is_approval_required} id={mIndex} onChange={(e) => this.props.onChangeStatusRawMaterial(e, mIndex)}/>
                                                    <label htmlFor={mIndex}></label>
                                                </div>
                                                {/* <div>{material.approverMessage}</div> */}
                                            </td>
                                            <td className={isUnEditable ? 'disabled' : ''}>
                                                <Input 
                                                    className={'fs-14'}
                                                    placeholder={'Enter Remarks'}
                                                    value={material.remarks}
                                                    name={'remarks'}
                                                    onChange={(e) => this.props.onChangeRawMaterial(e, mIndex)}
                                                />
                                            </td>
                                            <td>
                                                {material.raw_material_id && !material.is_accept && <div className={'flex'}>
                                                    <div className={'pv-5 pl-5 pr-5 border-theme-1 dark-blue br-5 fs-12 mr-10 fSemibold curP'} onClick={() => this.props.onUpdateRawMaterial(material, partData)}>Update</div>
                                                    <Edit className={'wt-20 ht-20 curP'} fill={'#627fe9'} onClick={() => onClickEdit(material.raw_material_id)}/>
                                                </div>}
                                                {(!material.raw_material_id && rawMaterials.length > 1) && <Delete className='wt-20 ht-20' onClick={() => this.props.onDeleteRawMaterials(mIndex)}/>}
                                                {
                                                    material.approverMessage && <div className={material.is_accept == 1 ? 'success-color fs-14' : 'error-color fs-14'}>{material.approverMessage}</div>
                                                }
                                                {material.rejected_remarks &&
                                                    <div className={'mt-5'}>{material.rejected_remarks}</div>
                                                }
                                            </td>
                                            </tr>)})}
                                        </> : 
                                        <>
                                            <tr>
                                                <th className={'wt-200'}>Product Type</th>
                                                <th>Product Description</th>
                                                <th className={'wt-150'}>Product Grade</th>
                                                <th className={'wt-100'}>Required Quantity</th>
                                                <th>Required Date</th>
                                                <th>Expected Date</th>
                                                <th>Upload Document</th>
                                                <th>Remark</th>
                                                <th>Action</th>
                                            </tr>
                                    
                                            {(rawMaterials || []).map((material, mIndex) => { 
                                                return(
                                                <tr>
                                                    <td>{material.product_type}</td>
                                                    <td>{material.product_description}</td>
                                                    <td>{material.product_grade}</td>
                                                    <td>{material.required_quantity}</td>
                                                    <td>{material.required_date && Moment(material.required_date).format('DD/MM/YYYY')}</td>
                                                    <td>{material.expected_date && Moment(material.expected_date).format('DD/MM/YYYY')}</td>
                                                    <td>
                                                        {(material.uploaded_doc || {}).name && <div className={'uploaded-data fs-14'}>
                                                                <a href={(material.uploaded_doc || {}).url} download><PhotoLibrary className="mr-10 wt-15 ht-15" />{(material.uploaded_doc || {}).name}</a>
                                                        </div>}
                                                    </td>
                                                    <td>
                                                        {material.remarks}
                                                    </td>
                                                    <td>
                                                            {material.is_approval_required && !material.is_accept && <div className={'flex'}>
                                                                <div className={'pv-5 pl-5 pr-5 border-theme-1 dark-blue br-5 fs-12 mr-10 fSemibold wt-60 curP'} onClick={() => onClickApproveOrReject(1, 1, material, partData)}>Approve</div>
                                                                <div className={'pv-5 pl-5 pr-5 loi-cancelled-color border-red  br-5 fs-12 fSemibold wt-60 curP'} onClick={() => this.handleReject(material)}>Reject</div>
                                                            </div>}
                                                            {
                                                                material.approverMessage && <div className={material.is_accept == 1 ? 'success-color fs-14' : 'error-color fs-14'}>{material.approverMessage}</div>
                                                            }
                                                    </td>
                                                </tr> )})}
                                        </>
                                        }
                                    </table>
                                </div>
                            </div>
                            {isSupplier && !(rawMaterials || []).find(el => el.raw_material_id) && <div className={'mt-20 tCenter'}>
                                <button className={'divButton bgPrimary'} onClick={() => this.props.onSaveRawMaterials(partData)}>Save</button>
                            </div>}
                        </div>
                </ModalT1>
                {this.state.isRejectPopup && 
                <RemarksConfirmationPopup 
                    onChange={(e) => this.setState({ remarks: e.target.value })}
                    onCancel={this.handleReject}
                    onConfirm={this.onConfirm}
                    value={this.state.remarks}
                />}
            </Fragment>
        )
    }
}

export default RawMaterialStatus;